/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billingoverviewplan2Inputs */

const en_billingoverviewplan2 = /** @type {(inputs: Billingoverviewplan2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your plan`)
};

const de_billingoverviewplan2 = /** @type {(inputs: Billingoverviewplan2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Plan`)
};

/**
* | output |
* | --- |
* | "Your plan" |
*
* @param {Billingoverviewplan2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const billingoverviewplan2 = /** @type {((inputs?: Billingoverviewplan2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billingoverviewplan2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billingoverviewplan2(inputs)
	return de_billingoverviewplan2(inputs)
});
export { billingoverviewplan2 as "billingOverviewPlan" }